import { render, staticRenderFns } from "./ykc-form.vue?vue&type=template&id=601e7c80"
import script from "./ykc-form.vue?vue&type=script&lang=js"
export * from "./ykc-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports